export default "__VITE_ASSET__DndhkzbV__"